import { useEffect, useState } from "react";
import { useNavigate, useLocation, } from 'react-router-dom';
import { NavigationType, useNavigationType } from "react-router-dom";

const useBlockBackButtom = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [newLocation, setNewLocation] = useState();
    const navigationType = useNavigationType();

    useEffect(() => {
        if (navigationType === NavigationType.Pop) {
            if (newLocation !== undefined || newLocation !== pathname) {
                setNewLocation(pathname);
                return navigate(1)
            }
            return navigate(newLocation, { replace: true })
        }
    }, [navigate, navigationType, newLocation, pathname]);
}

export default useBlockBackButtom;